<main class="gratuity_detail" v-if="gratuityStaff">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{ _(app.gratuity.texts.title) }}</h1>
            <span class="icon back" @click="app.setPage('GratuityList')"
                >chevron_left</span
            >
        </div>
    </header>
    <div id="background"></div>
    <img class="staff_image" :src="gratuityStaff.image_urls[0]" />
    <div class="descriptions">
        <h2 class="title">{{ _(gratuityStaff.texts.staff_name) }}</h2>
        <p style="white-space: pre-line">
            {{ _(gratuityStaff.texts.staff_description) }}
        </p>
    </div>

    <template v-if="app.reserves_rooms.length > 1" class="wrap-input select">
        <hr />
        <div class="pulldown_column">
            <h3 class="talign_right">{{_('per_room')}}</h3>
            <div>
                <label
                    v-if="app.reserves_rooms.length > 1"
                    class="wrap-input select"
                >
                    <select v-model="selectRoomId">
                        <option v-for="rr in app.reserves_rooms" :value="rr.id">
                            {{_('room_count', rr.index)}} ({{_(rr.name)}})
                        </option>
                    </select>
                </label>
            </div>
        </div>
    </template>

    <template>
        <hr />
        <div class="pulldown_column">
            <h3>
                {{ _('gratuity_price') }}<span class="primary-label ml_10px"
                    >{{ _('mandatory_field') }}</span
                >
            </h3>
            <div>
                <label class="wrap-input input">
                    <input
                        type="number"
                        :placeholder="`¥${minAmount}~${maxAmount}`"
                        v-model="inputAmount"
                        :min="minAmount"
                        :max="maxAmount"
                        @blur="handleBlur"
                        @change="handleBlur"
                    />
                </label>
            </div>
        </div>
    </template>

    <template v-if="_(app.gratuity.texts.message_description).length > 0">
        <hr />
        <div class="pulldown_column">
            <h3>{{_(app.gratuity.texts.message_description)}}</h3>
            <label
                class="wrap-input textarea"
                style="max-width: 740px; width: 100%"
            >
                <textarea v-model="comment"></textarea>
            </label>
        </div>
    </template>

    <template v-if="app.gratuity.texts.notice[app.getLang()].length > 0">
        <hr />
        <div class="pulldown_column">
            <section class="remarks">
                <pre>{{ _(app.gratuity.texts.notice) }}</pre>
            </section>
        </div>
    </template>

    <div
        id="cart-bar"
        v-if="inputAmount >= minAmount && inputAmount <= maxAmount"
    >
        <div class="cart-bar-content">
            <div class="cart-bar-el">
                <div class="cart_and_total_amount">
                    <span class="total_amount">{{ inputAmount | price }}</span>
                    <span class="yen"></span>
                </div>
            </div>
            <button @click="addOrder()">{{_('confirm')}}</button>
        </div>
    </div>
</main>
